import { render, staticRenderFns } from "./MedicalDocument.vue?vue&type=template&id=2c140b0a&scoped=true&"
import script from "./MedicalDocument.vue?vue&type=script&lang=js&"
export * from "./MedicalDocument.vue?vue&type=script&lang=js&"
import style0 from "./MedicalDocument.vue?vue&type=style&index=0&id=2c140b0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c140b0a",
  null
  
)

export default component.exports